import React from "react";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CustomToggleButton from "../../Components/CustomToggleButton";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function SettingsIcon({ setting, handleSettingClick }) {
  const { t } = useTranslation();
  const handleClick = () => handleSettingClick(setting);

  switch (setting.type) {
    case "timeViewButton":
      return (
        <CustomToggleButton
          buttons={[
            { id: "time", title: t("timeline.buttons.interaction") },
            { id: "day", title: t("timeline.buttons.day") },
            { id: "week", title: t("timeline.buttons.week") },
          ]}
          selected={setting.value}
          handleClick={(view) =>
            handleSettingClick({ ...setting, value: view })
          }
        />
      );

    case "clockViewButton":
      return (
        <CustomToggleButton
          buttons={[
            { id: "morning", title: t("moodboards.settings.clock.morning") },
            { id: "noon", title: t("moodboards.settings.clock.noon") },
            { id: "evening", title: t("moodboards.settings.clock.evening") },
            { id: "night", title: t("moodboards.settings.clock.night") },
          ]}
          selected={setting.value}
          handleClick={(view) =>
            handleSettingClick({ ...setting, value: view })
          }
        />
      );

    case "switch":
      return (
        <ListItem button onClick={handleClick} disabled={setting?.disabled}>
          <ListItemIcon>
            <Switch color="primary" checked={setting.value} size="small" />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body2">{setting.name}</Typography>
          </ListItemText>
        </ListItem>
      );

    case "link":
      return (
        <ListItem button onClick={handleClick}>
          <ListItemIcon>
            <HelpOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body2">{setting.name}</Typography>
          </ListItemText>
        </ListItem>
      );

    default:
      return "";
  }
}
